  <template>
  <div class="card">
    <input
      id="requestFaqFileInput"
      ref="file"
      type="file"
      style="display: none"
      @change="setPhoto"
    >
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4>{{ $t('requestFaq.sualCavab') }}</h4>
        <div v-if=" canParticipate">
          <button
            v-if="!faqAskFormOpen"
            class="btn btn-sm btn-light-primary"
            @click.prevent="faqAskFormOpen= true"
          >
            {{ $t('requestFaq.yeniSualVer') }}
          </button>
        </div>
      </div>
      <hr>

      <div v-if=" canParticipate && faqAskFormOpen">
        <form @submit.prevent="addFaqQuestion">
          <div class="mb-3">
            <input
              v-model="faqAskQuestion"
              class="form-control"
              type="text"
              required
              :placeholder="$t('requestFaq.sualMtniniDaxilEdin')"
            >
          </div>
          <div class="mb-3">
            <button
              class="btn btn-sm btn-light-primary mr-2"
              type="submit"
            >
              {{ $t('body.gndr') }}
            </button>
            <button
              class="btn btn-sm btn-light-dark mr-2"
              type="button"
              @click="faqAskFormOpen=false"
            >
              {{ $t('companyProfile.lvEt2') }}
            </button>
          </div>
        </form>
        <hr>
      </div>


      <div
        v-if="requestFaq.length<1"
        class="alert alert-danger"
      >
        <span v-if="request.requestType === 'AUC'">{{ $t('requestFaq.hrraclaBalSualYoxdur') }}</span>
        <span v-else-if="request.requestType === 'REV'">{{ $t('requestFaq.ksHrraclaBalSualYoxdur') }}</span>
        <span v-else>{{ $t('requestFaq.soruIlBalSualYoxdur') }}</span>
      </div>

      <div v-else>
        <div class="alert alert-primary mb-3">
          {{ $t('requestFaq.suallarVCavablarBtnItiraklaraGrnrMvzudanKnarSualTk') }}
        </div>

        <div
          v-for="(question,i) in requestFaq"
          :key="question.id"
        >
          <div class="d-flex justify-start">
            <div class="mr-3">
              <span class="badge badge-success">{{ $t("requestParticipants.itirak") }}# {{ question.requestUser.userOrder }}</span> <br>
              <span
                v-if="requestUser && requestUser.userOrder === question.requestUser.userOrder "
                class="small"
              >
                {{ $t('aucPrices.buSizsiniz') }}
              </span>
            </div>

            <div class="w-100">
              <div class="rounded bg-light text-dark p-3 mb-3">
                <div v-if="question.status !== 'REJECTED'">
                  {{ question.question }}


                  <template v-if="question.status=== 'NEW'">
                    <div v-if="isMyRequest && request.status ==='ACTIVE'">
                      <a
                        v-if="answering.indexOf(question.id) === -1"
                        href="#"
                        class="text-primary"
                        @click.prevent="answering.push(question.id)"
                      >
                        <u>{{ $t('requestFaq.cavabVer') }}</u>
                      </a>
                    </div>
                    <div v-else>
                      <div class="text-warning">
                        {{ $t('requestFaq.buSualCavablanmayb') }}
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-else
                  class="text-danger"
                >
                  {{ $t('requestFaq.sualBloklanb') }}
                </div>
              </div>

              <div v-if="question.status === 'ANSWERED'">
                <span class="badge badge-primary">{{ $t('request.soruMllifi') }}</span>
                <div class="rounded bg-light text-dark p-3 mt-2 mb-3">
                  - {{ question.answer }}
                  <div
                    v-if="question.file"
                    class="my-2"
                  >
                    <a
                      class="requestFile border border-bottom-secondary rounded p-1"
                      :href="getPhoto(question.file, '')"
                      target="_blank"
                    >
                      <i
                        v-if="isPhoto(question.file)"
                        class="fa fa-fw fa-photo"
                      />
                      <i
                        v-else
                        class="fa fa-fw fa-paperclip"
                      />
                      {{ (question.file || '').split('/').pop() }}
                    </a>
                  </div>
                </div>
              </div>
              <div v-else-if="question.status === 'REJECTED'">
                <span class="badge badge-primary">{{ $t('request.soruMllifi') }}</span>

                <div class="alert alert-danger mt-2">
                  <span v-if="question.answeredBy==='admin'">
                    <strong v-if="question.requestUser.userStatus==='BLOCKED'">{{ $t('requestFaq.itirakAdminTrfindnBloklanb') }} </strong>
                    <strong v-else>{{ $t('requestFaq.sualAdminTrfindnBloklanb') }} </strong> <br>
                    <em>{{ question.answer }}</em>
                  </span>
                  <span v-else>
                    <strong v-if="question.requestUser.userStatus==='BLOCKED'">{{ $t('requestFaq.itirakBloklanb') }} </strong>
                    <strong v-else>{{ $t('requestFaq.sualBloklanb') }}</strong> <br>
                    <span>{{ question.answer }}</span>
                  </span>
                </div>
                <div v-if="isMyRequest && question.answeredBy!=='admin'">
                  <button
                    v-if="question.requestUser.userStatus==='BLOCKED'"
                    class="btn btn-sm btn-light-danger mr-2"
                    type="button"
                    @click="unBlockRequestUser(question)"
                  >
                    <span>{{ $t('requestFaq.itiraknBlokdanXar') }}</span>
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-light-warning mr-2"
                    type="button"
                    @click="unRejectFaqQuestion(question)"
                  >
                    <span>{{ $t('requestFaq.sualBlokdanXar') }}</span>
                  </button>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="isMyRequest && request.status ==='ACTIVE' && answering.indexOf(question.id)>-1 "
                  class="rounded bg-light text-dark p-3 mt-2 mb-3"
                >
                  <form @submit.prevent="answerFaqQuestion(i)">
                    <div class="mb-3">
                      <textarea
                        v-model="faqQuestionAnswers[i]"
                        class="form-control"
                        type="text"
                        required
                        :placeholder="$t('requestFaq.cavabDaxilEdin')"
                      />
                    </div>

                    <div
                      v-if="faqQuestionFiles[i]"
                      class="mb-3"
                    >
                      <div class="requestFile p-1 d-flex justify-content-between">
                        <a
                          class=""
                          :href="getPhoto(faqQuestionFiles[i], '')"
                          target="_blank"
                        >
                          <i
                            v-if="isPhoto(faqQuestionFiles[i])"
                            class="fa fa-fw fa-photo"
                          />
                          <i
                            v-else
                            class="fa fa-fw fa-paperclip"
                          />
                          {{ (faqQuestionFiles[i] || '').split('/').pop() }}
                        </a>
                        <a
                          class="cursor-pointer text-dark"
                          @click.prevent="faqQuestionFiles[i]=''"
                        >
                          <i class="fa fa-times" />
                        </a>
                      </div>
                    </div>
                    <div
                      v-else
                      class="mb-3"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="selectPhoto(i)"
                      >
                        <i class="fa fa-paperclip" /> {{ $t('requestFaq.faylLavEt') }}
                      </button>
                    </div>


                    <div class="mb-3">
                      <button
                        class="btn btn-sm btn-primary mr-2"
                        type="submit"
                      >
                        <span>{{ $t('requestFaq.cavabla') }}</span>
                      </button>

                      <button
                        class="btn btn-sm btn-light mr-2"
                        type="button"
                        @click.prevent="cancelAnswering(question.id)"
                      >
                        <span>{{ $t('companyProfile.lvEt2') }}</span>
                      </button>

                      <button
                        class="btn btn-sm btn-light-danger mr-2"
                        type="button"
                        @click="blockRequestUser(question)"
                      >
                        <span>{{ $t('requestFaq.itiraknBlokla') }}</span>
                      </button>
                      <button
                        class="btn btn-sm btn-light-warning mr-2"
                        type="button"
                        @click="rejectFaqQuestion(question)"
                      >
                        <span>{{ $t('requestFaq.sualLvEt') }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {
  answerFaqQuestion,
  askFaqQuestion,
  blockRequestUser, getRequestFaq,
  rejectFaqQuestion, unBlockRequestUser, upload
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {getPhoto} from "@/repositories/Utils";

export default {
  name: 'RequestFAQ',
  props: {
    isMyRequest: {},
    canParticipate: {},
    request: {},
    requestUser: {},
  },
  data() {

    return {
      updateTimer: null,
      requestFaq: [],
      faqAskFormOpen: false,

      faqAskQuestion: '',
      faqQuestionAnswers: {},
      faqQuestionFiles: {},
      fileIndex: -1,

      answering: [],
    }

  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
    }),


  },

  mounted() {
    this.loadFaqList();
    this.updateTimer = setInterval(() => {
      this.loadFaqList();
    }, 3000);
  },

  beforeDestroy() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer);
    }
  },

  methods: {
    addFaqQuestion() {
      if (this.isEmail(this.faqAskQuestion) || this.isPhone(this.faqAskQuestion)) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("elaqeMlmtlQydEdlmsYol"),
          icon: 'error'
        })
      } else {
        askFaqQuestion(this.token, this.request.id, this.faqAskQuestion).then(data => {
          if (data.code === 200) {
            this.loadFaqList();
            this.faqAskQuestion = '';
            this.faqAskFormOpen = false;
          } else if (data.code === 403) {

            let message = data.message;
            if (data.errorCode === 'you_blocked_but_company_can_join') {
              message = this.$t("sznSualVrmrImknnzBlklnb");
            } else if (data.errorCode === 'you_blocked') {
              message = this.$t("aucPrices.youBlocked");
            }

            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: message,
              icon: 'error'
            })
          } else if (data.code === 409) {

            let message = data.message;

            if (data.errorCode === 'company_already_participating') {
              message = this.$t("aucPrices.fromYourCompany") + data.user + this.$t("aucPrices.fromYourCompany");
            } else if (data.errorCode === 'user_already_participating') {
              message = this.$t("aucPrices.you") + data.company + this.$t("aucPrices.istirakEdirsiz");
            }

            this.$swal({
              title: `Diqqət (${data.code})`,
              text: `${message}`,
              icon: 'error'
            })
          } else {
            this.$swal({
              title: `Xəta ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      }
    },

    isEmail(text) {
      return text.includes('@') ||
          text.includes('mail') ||
          text.includes('yandex') ||
          text.includes('outlook') ||
          text.includes('yahoo') ||
          text.includes('hotmail') ||
          text.includes('gmail') ||
          text.includes('.az') ||
          text.includes('.info') ||
          text.includes('.com');
    },

    isPhone(text) {
      return text.replace(/\D/g, '').length > 8;
    },
    answerFaqQuestion(index) {

      if (this.isEmail(this.faqQuestionAnswers[index]) || this.isPhone(this.faqQuestionAnswers[index])) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("elaqeMlmtlQydEdlmsYol"),
          icon: 'error'
        })
      } else {

        answerFaqQuestion(this.token, this.requestFaq[index]['id'], this.faqQuestionAnswers[index], (this.faqQuestionFiles[index] || '')).then(data => {
          if (data.code === 200) {
            this.loadFaqList();
          } else {
            this.$swal({
              title: `Xəta ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      }
    },
    rejectFaqQuestion(question) {
      this.$swal({
        title: this.$t("blklmSbbDxlEdin"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          rejectFaqQuestion(this.token, question.id, result.value).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    unRejectFaqQuestion(question) {
      this.$swal({
        title: this.$t("slCvblyn"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("sliCvbla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          answerFaqQuestion(this.token, question.id, result.value, '').then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Xəta ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    blockRequestUser(question) {
      this.$swal({
        title: this.$t("istrkcnBlklmqSbb"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          blockRequestUser(this.token, question.id, result.value).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Xəta ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },

    unBlockRequestUser(question) {
      this.$swal({
        title: this.$t("istrkcnBlkdnCxrmq"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkdnCxr"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          unBlockRequestUser(this.token, question.id).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },

    loadFaqList() {
      getRequestFaq(this.token, this.request.id).then(list => {
        this.requestFaq = list;
      })
    },


    selectPhoto(index) {
      this.fileIndex = index;
      window.document.getElementById('requestFaqFileInput').click();
    },

    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'faqAnswer', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.faqQuestionFiles[this.fileIndex] = response.data.path;
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text:  this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },

    cancelAnswering(id) {
      this.answering = this.answering.filter(i => i !== id);
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>